import * as angular from "angular";

angular
  .module('bringoz.admin.teams')
  .config(teamsConfig);

/* @ngInject */
function teamsConfig($stateProvider) {

  $stateProvider

    // Teams
    .state('teams', {
      parent: 'bringoz.site',
      url: '/teams',
      template: '<teams-view></teams-view>',
      controller: function ($scope, triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Teams"});
        triBreadcrumbsService.addCrumb({name: "Administration"});
      }
    })

}
